<template>
  <div class="content-warpper">
    <div class="warpper-title flex align-center justify-between">
      <div>
        <i class="iconfont iconjigou2"></i>
        考场详情
      </div>
      <div v-if="!isExamine">
<!--        <el-button type="primary">上传盖章</el-button>-->
        <el-button type="danger" v-if="orgDetail" @click="closeItem(orgDetail.status === 1?0:1)">{{orgDetail.status === 1?'冻结机构':'解除冻结'}}</el-button>
      </div>

    </div>
    <div class="padding-sm flex align-start justify-between detail-warpper" v-if="orgDetail">
      <div class="flex-sub info-warpper">
        <h2 class="flex align-center detail-title margin-bottom-xs">
          <span class="margin-right">机构指标</span>
          <el-select v-model="year" placeholder="请选择年份" @change="tongji">
            <el-option
                v-for="item in yearOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </h2>
        <div class="flex align-center flex-wrap margin-bottom">
          <div class="detail-num ">
            <span>年度承接考试总数量</span>
            <b><i>{{ cjnum }}</i></b>
          </div>
          <div class="detail-num ">
            <span>年度拒绝承接考试数量</span>
            <b><i>{{ refuseNum }}</i></b>
          </div>
<!--          <div class="detail-num ">-->
<!--            <span>投诉考场/考务</span>-->
<!--            <b><i>500</i></b>-->
<!--            <router-link to="/" class="link-text">查看</router-link>-->
<!--          </div>-->
<!--          <div class="detail-num ">-->
<!--            <span>其他投诉</span>-->
<!--            <b><i>500</i></b>-->
<!--            <router-link to="/" class="link-text">查看</router-link>-->
<!--          </div>-->
        </div>
        <h2 class="flex align-center detail-title margin-bottom-xs"><span>考场机构信息</span></h2>
        <el-row class="org-info">
          <el-col :span="4"><div class="label-box">机构名称</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.org_name }}</div></el-col>
          <el-col :span="4"><div class="label-box">授权编号</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.org_num }} </div></el-col>
          <el-col :span="4"><div class="label-box">机构组织代码</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.org_code }} </div></el-col>
          <el-col :span="4"><div class="label-box">机构所在地</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.regionArr }}{{orgDetail.address}}</div></el-col>
          <el-col :span="4"><div class="label-box">联系人姓名</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.username }}</div></el-col>
          <el-col :span="4"><div class="label-box">联系人手机号</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.phone }}</div></el-col>
          <el-col :span="4"><div class="label-box">联系人职务</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.zhiwu }}</div></el-col>
          <el-col :span="4"><div class="label-box">联系人邮箱</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.email }}</div></el-col>
          <el-col :span="4"><div class="label-box">到期时间</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.due_date }}</div></el-col>
          <el-col :span="4"><div class="label-box">隶属协调中心</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.xtzx_name }}</div></el-col>

        </el-row>

        <div class="flex align-start margin-tb">
          <h3 class="margin-right">营业执照</h3>
          <el-image
              style="width: 200px; height: 150px"
              :src="imgUrl + orgDetail.org_license"
              :preview-src-list="[imgUrl + orgDetail.org_license]">
          </el-image>
        </div>
        <div class="flex align-start margin-tb" v-if="orgDetail.longitude">
          <h3 class="margin-right">地理位置</h3>
          <div class="flex-sub">
            <div id="map-container" style="width:100%;height:300px;"/>


          </div>
        </div>
        <div class="quest-item">
          <p class="quest-title">到达您机构位置的公共交通方式及路线，包括公交、地铁线路，具体哪路公交车，哪条地铁，在哪一站出站</p>
          <div class="anwer-info">{{ orgDetail.way }}</div>
        </div>

        <div>
          <h3 class="detail-small-title">二、申请单位生源信息</h3>
          <div class="quest-item">
            <p class="quest-title">请通过附件说明</p>
            <div class="anwer-info">
              <el-link type="primary" :href=" fileUrl +orgDetail.huanjing_file" target="_blank">附件:{{orgDetail.huanjing_file}}（点击下载）</el-link>
            </div>
          </div>
        </div>
        <div>
          <h3 class="detail-small-title">三、 申请单位的网络情况</h3>
          <div class="quest-item">
            <p class="quest-title">考场是否有无线Wi-Fi网络覆盖</p>
            <div class="anwer-info">
              <span v-if="Number(orgDetail.wifi_env) === 0" class="margin-right active"><i class="iconfont iconxuanzhong"></i> 完全覆盖考场</span>
              <span v-if="Number(orgDetail.wifi_env) === 1" class="margin-right active"><i class="iconfont iconxuanzhong"></i>  部分覆盖考场</span>
              <span v-if="Number(orgDetail.wifi_env) === 2" class="margin-right active"><i class="iconfont iconxuanzhong"></i>  无法覆盖考场</span>
            </div>
          </div>

          <div class="quest-item">
            <p class="quest-title">实测无线网络对公网的上传/下载速率</p>
            <div class="anwer-info">{{ orgDetail.wifi_sulv }}</div>
          </div>
          <div class="quest-item">
            <p class="quest-title">无线网络支持的最大接入数量</p>
            <div class="anwer-info">{{ orgDetail.wifi_max }}</div>
          </div>


        </div>
        <div>
          <h3 class="detail-small-title">四、申请单位可以提供的考场的平面图和说明</h3>
          <div class="quest-item">
            <p class="quest-title">考场平面图 请标明考场数量、面积，考场内桌椅数量等</p>
            <div class="anwer-info"> <el-link type="primary" :href=" fileUrl +orgDetail.env_image" target="_blank">附件:{{orgDetail.env_image}}（点击下载）</el-link></div>
          </div>
        </div>
        <div>
          <h3 class="detail-small-title">五、申请单位可以提供的音视频设备和说明</h3>
          <div class="quest-item">
            <p class="quest-title">考场可提供的设备   考试采用小组现场讨论方式，基本考试单位样式见文末示意图</p>
            <div class="anwer-info margin-bottom-xs">

              <span v-for="(item,index) in orgDetail.shebei" :key="index" class="margin-right active"><i class="iconfont iconxuanzhong"></i> {{ item }}</span>
              <p class="margin-top-sm" v-if="orgDetail.other_shebei">其他：{{orgDetail.other_shebei}}</p>
            </div>


            <div class="flex align-start margin-tb">
              <h3 class="margin-right">考场示意图</h3>
              <el-image
                  style="width: 100px; height: 100px"
                  :src="kaochangImg"
                  :preview-src-list="[kaochangImg]">
              </el-image>
            </div>
            <p></p>
          </div>
        </div>

        <div>
          <h3 class="detail-small-title">六、 申请单位可以提供的考务人员情况</h3>
          <div class="quest-item flex align-center">
            <p class="quest-title quest-title-line">教师人数</p>
            <div class="anwer-info flex-sub">{{ orgDetail.teacher }}</div>
          </div>
          <div class="quest-item flex align-center">
            <p class="quest-title quest-title-line">保安人数</p>
            <div class="anwer-info flex-sub">{{ orgDetail.pro }}</div>
          </div>
          <div class="quest-item flex align-center">
            <p class="quest-title quest-title-line">志愿者人数</p>
            <div class="anwer-info flex-sub">{{ orgDetail.zhi }}</div>
          </div>
        </div>



        <div>
          <h3 class="detail-small-title">七、其他信息</h3>
          <div class="quest-item flex align-center">
            <p class="quest-title quest-title-line">最大承接数</p>
            <div class="anwer-info flex-sub">{{ orgDetail.bear_num }}</div>
          </div>
          <div class="quest-item">
            <p class="quest-title">备注信息</p>
            <div class="anwer-info">{{ orgDetail.remark }}</div>
          </div>
        </div>
        <div class="margin-tb flex align-center justify-around" v-if="isExamine">
          <nianExamine :org-type="4" :xtzx_id="orgDetail.xtzx_id"/>
        </div>
      </div>
      <time-list :id="id" :type="4"/>


    </div>
  </div>
</template>
<script>
import loadBMap from "@/tools/utils";
import {orgOne, orgSet, orgTongji, shenheDetail} from "@/api/projectOffice";
import {CodeToText} from "element-china-area-data";
import {FILEURL, IMGURL} from "@/config";
import kaochang from '@/assets/img/kaochang.png'
import timeList from "@/views/projectOffice/page/conponents/timeList";
import nianExamine from "@/views/projectOffice/page/conponents/nianExamine";
export default {
  name: "organizationDetail3",
  data() {
    return {
      id: '',
      year: '',
      yearOptions: [],
      cjnum: 0,
      refuseNum: 0,
      orgDetail: null,

      kaochangImg:kaochang,
      isExamine:false
    }
  },
  components:{
    timeList,
    nianExamine
  },
  computed:{
    imgUrl() {
      return IMGURL
    },
    fileUrl(){
      return FILEURL
    }
  },
  created() {
    this.id = Number(this.$route.query.id)
    if(this.$route.query.nian && (Number(this.$route.query.shenType) === 0 || Number(this.$route.query.shenType) === 1)) this.isExamine = true
    this.$emit(
        "setIndex",
        this.isExamine?'/projectOffice/annualReview':'/projectOffice/organization',
        "当前位置：机构管理 > <span>考场详情</span> ",
        true
    );
    this.getDetail();
    this.tongji();
  },
  async mounted() {
    await loadBMap("McBWgFElxpnhhnO5kHHthQyG2KRsHLZS"); //加载引入BMap
  },
  methods: {

    //  统计
    async tongji(){
      let _data = this.$route.query.nian?await shenheDetail(this.$route.query.shenId,4) :await orgTongji(this.id, 4, this.year)
      _data.data.year.map(item => {
        this.yearOptions.push({label: item + '年', value: item})
      })
      this.year = _data.data.year[_data.data.year.length - 1]
      this.cjnum = _data.data.data.cjnum
      this.refuseNum = _data.data.data.refuseNum
    },
    //  详情
    async getDetail() {
      let _data = await orgOne(this.id,4)
      let _arr = _data.data.region_text.split(',')
      _data.data.regionArr = CodeToText[_arr[0]] +  CodeToText[_arr[1]] +  CodeToText[_arr[2]]
      _data.data.latitude = Number(_data.data.latitude)
      _data.data.longitude = Number(_data.data.longitude)
      _data.data.shebei =_data.data.shebei ?  _data.data.shebei.split(',') : ''
      this.orgDetail = _data.data
      if(this.orgDetail.longitude){
        this.$nextTick(()=>{
          this.initMap();
        })
      }
    },
    //  冻结
    closeItem(state) {
      this.$confirm(state === 0?"确定要冻结该机构吗？":"确定要解除该机构的冻结吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureClose(state);
      });
    },
    async sureClose(state) {
      let _state = await orgSet(this.$route.query.id,4, state);
      this.getDetail();
      this.$message.success(_state.msg);
    },

    //  地图部分
    initMap() {
      var that = this;
      // 1、挂载地图
      this.map = new BMap.Map("map-container", {enableMapClick: false});
      var point = new BMap.Point(this.orgDetail.longitude,this.orgDetail.latitude);
      this.map.centerAndZoom(point, 16);
      // this.map.enableScrollWheelZoom(true);

      // 3、设置图像标注并绑定拖拽标注结束后事件
      this.mk = new BMap.Marker(point, {enableDragging: true});
      this.map.addOverlay(this.mk);
      // this.mk.addEventListener("dragend", function (e) {
      //   that.getAddrByPoint(e.point);
      // });
      // 4、添加（右上角）平移缩放控件
      this.map.addControl(
          new BMap.NavigationControl({
            anchor: BMAP_ANCHOR_TOP_RIGHT,
            type: BMAP_NAVIGATION_CONTROL_SMALL
          })
      );
      // 5、添加（左下角）定位控件
      var geolocationControl = new BMap.GeolocationControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
      });
      geolocationControl.addEventListener("locationSuccess", function (e) {
        that.getAddrByPoint(e.point);
      });
      geolocationControl.addEventListener("locationError", function (e) {
        alert(e.message);
      });
      this.map.addControl(geolocationControl);
      // 6、浏览器定位
      // this.geolocation()
      // 7、绑定点击地图任意点事件
      // this.map.addEventListener('click', function (e) {
      //   that.getAddrByPoint(e.point)
      // })
    }
  }
}
</script>

<style scoped lang="scss">
.detail-warpper {
  .info-warpper {
    .detail-title {
      height: 60px;

      span {
        display: block;
        line-height: 29px;
        font-size: 22px;
        padding-left: 15px;
        position: relative;

        &:before {
          position: absolute;
          left: 0;
          top: 0;
          content: '';
          width: 8px;
          height: 29px;
          background-color: #009688;
          border-radius: 4px;
        }
      }
    }

    .detail-num {
      width: 30%;
      padding: 10px;
      background-color: #ffffff;
      border: solid 1px #dae6f1;
      font-size: 18px;
      margin-right: 3%;
      margin-bottom: 10px;

      span {
        display: block;
        margin-bottom: 10px;
      }

      b {
        font-size: 18px;

        i {
          color: #009688;

        }
      }

      .link-text {
        margin-left: 10px;
        color: #009688;
        font-size: 18px;
      }
    }


    .org-info {
      .label-box {
        display: flex;
        align-items: center;
        height: 48px;
        padding-left: 20px;
        background: #eef7ff;
        border: solid 1px #dae6f1;
      }

      .info-box {
        display: flex;
        align-items: center;
        height: 48px;
        padding-left: 20px;
        background: #fff;
        border: solid 1px #dae6f1;
      }
    }

    .detail-small-title {
      line-height: 30px;
      font-size: 18px;
    }

    .quest-item {
      margin: 10px 0 20px;
      padding-left: 32px;

      .quest-title {
        margin-bottom: 10px;
        &.quest-title-line{
          width: 120px;
          text-align: left;
          margin-bottom: 0;
        }
      }

      .anwer-info {
        width: 100%;
        padding: 15px;
        background-color: #f1f1f1;
        border-radius: 4px;

        .active {
          color: #009688;
        }
      }
    }
  }

  .time-list {

    margin-left: 30px;
    width: 340px;
    padding: 30px;
    background-color: #ffffff;
    border: solid 1px #dae6f1;

    p {
      width: 90px;
      height: 20px;
      margin: 0 auto 30px;
      font-size: 18px;
      font-weight: bold;
      line-height: 30px;
      position: relative;
      text-align: center;

      &:before {
        position: absolute;
        left: -20px;
        top: 14px;
        content: '';
        width: 20px;
        height: 2px;
        background-color: #009688;
      }

      &:after {
        position: absolute;
        right: -20px;
        top: 14px;
        content: '';
        width: 20px;
        height: 2px;
        background-color: #009688;
      }
    }
  }

}

</style>